import { isLinkActive } from '@/app/layouts/AsideMenu';
import { REVISED_ACCOUNTS_ITEMS, REVISED_ACCOUNTS_LABEL } from './menuItems';
import { SectionNav } from './SectionNav';

/** True on the two screens of the Revised Accounts section (APT370). */
export const isRevisedAccountsRoute = (pathname: string): boolean =>
  REVISED_ACCOUNTS_ITEMS.some((i) => isLinkActive(pathname, i.to));

/**
 * APT370 (client): "Combine Revised Accounts and Revised Accounts Lineage under a single parent option named Revised Accounts ... following the
 * same layout and design used for Adjustments". The same bar as APT348's, in the client's order: Revised Accounts | Revised Accounts Lineage.
 */
export const RevisedAccountsNav = () => (
  <SectionNav label={REVISED_ACCOUNTS_LABEL} items={REVISED_ACCOUNTS_ITEMS} testId="revised-accounts-nav" />
);
